import { gsap, ScrollTrigger, Power1 } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

class LavaScale extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.containerMobile = this.querySelector('.container-mobile');
    this.indicator = this.querySelector('.scale-indicator');
    this.text = this.querySelector('.scale-text');

    this.scrollTriggerIdMobile = 'st-mobile';
    this.scrollTriggerIdDesktop = 'st-desktop';

    const mediaQuery = '(max-width: 1023px)';
    const mediaQueryList = window.matchMedia(mediaQuery);
    mediaQueryList.addEventListener('change', event => {
      if (event.target.matches) {
        this.destroyDesktop();
        this.initMobile();
      } else {
        this.destroyMobile();
        this.initDesktop();
      }
    });
    mediaQueryList.dispatchEvent(new Event('change'));


    // Parent ScrollTrigger
    const outerSt = new ScrollTrigger({
      trigger: '.scale-outer',
      start: () => 'top bottom',
      end:  () => 'bottom top',
      onLeaveBack: (self) => {
        if (ScrollTrigger.getById(this.scrollTriggerIdMobile)) {
          ScrollTrigger.getById(this.scrollTriggerIdMobile).animation.progress(0, true);
          ScrollTrigger.getById(this.scrollTriggerIdMobile).enable();
          let start = self.start;
          self.scroll(self.start);
          ScrollTrigger.refresh();
          window.scrollTo(0, start);
        }
        if (ScrollTrigger.getById(this.scrollTriggerIdDesktop)) {
          ScrollTrigger.getById(this.scrollTriggerIdDesktop).animation.progress(0, true);
          ScrollTrigger.getById(this.scrollTriggerIdDesktop).enable();
          let start = self.start;
          self.scroll(self.start);
          ScrollTrigger.refresh();
          window.scrollTo(0, start);
        }
      },
    });
  }


  initDesktop() {
    if (ScrollTrigger.getById(this.scrollTriggerIdDesktop)) {
      return;
    }

    this.tlDesktop = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdDesktop,
        trigger: '.scale-pin',
        pin: '.scale-pin',
        anticipatePin: 1,
        start: () => 'top 0',
        end: '+=' + Math.max(window.innerHeight * 2, 1640),
        scrub: true,
        // markers: true,

        onLeave: function (self) {
          let start = self.start;
          self.scroll(self.start);
          self.disable();
          self.animation.progress(1, true);
          ScrollTrigger.refresh();
          window.scrollTo(0, start);
        }
      },
    })
    .fromTo(this.indicator,
      { right: '10%' },
      { right: '34%' },
      { ease: Power1.easeInOut, duration: 1 }
    )
    .fromTo(this.text,
      { opacity: 0 },
      { opacity: 1 },
      { ease: Power1.easeInOut, duration: 1 },
      '-=0.75'
    );
  }

  destroyDesktop() {
    if (this.tlDesktop) {
      this.tlDesktop.kill();
    }

    const st = ScrollTrigger.getById(this.scrollTriggerIdDesktop);
    if (st) {
      st.kill();
    }
  }

  initMobile() {
    if (ScrollTrigger.getById(this.scrollTriggerIdMobile)) {
      return;
    }

    this.tlMobile = gsap.timeline({
      scrollTrigger: {
        id: this.scrollTriggerIdMobile,
        trigger: '.scale-pin',
        pin: '.scale-pin',
        anticipatePin: 1,
        start: () => "top 0",
        end: '+=' + Math.max(window.innerHeight * 2, 1280),
        scrub: true,
        onLeave: function (self) {
          let start = self.start;
          self.scroll(self.start);
          self.disable();
          self.animation.progress(1, true);
          ScrollTrigger.refresh();
          window.scrollTo(0, start);
        }
      },
    })
    .fromTo(this.containerMobile,
      { translateX: -(this.containerMobile.clientWidth - window.innerWidth)*(8/9) },
      { translateX: -(this.containerMobile.clientWidth - window.innerWidth)/1.61 },
      { ease: Power1.easeInOut, duration: 1 }
    )
    .fromTo(this.text,
      { opacity: 0 },
      { opacity: 1 },
      { ease: Power1.easeInOut, duration: 1 },
      '-=0.75'
    );
  }

  destroyMobile() {
    if (this.tlMobile) {
      this.tlMobile.kill();
    }

    const st = ScrollTrigger.getById(this.scrollTriggerIdMobile);
    if (st) {
      st.kill();
    }
  }

}


// Define the new web component
if ('customElements' in window) {
  customElements.define('lava-scale', LavaScale);
}
